import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/pirate-market-badge.png")